/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, August 18th 2023, 3:21:53 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import RemoveCircle from "@mui/icons-material/RemoveCircle";
import Stack from "@mui/material/Stack";
import { PaymentAPICredentials } from "lib/schemas";
import { CredentialStoreForm, CredentialStoreCard } from "integrations/components";
import { OSActionButton, useToggleState } from "ui-widgets";

interface PaymentCredentialsCardProps {
  paymentCredentials: PaymentAPICredentials;
  onUnassignCredential: () => void;
}

export const PaymentCredentialsCard = ({ paymentCredentials, onUnassignCredential }: PaymentCredentialsCardProps) => {
  const {
    handleClose: handleCloseCredentialStoreForm,
    handleOpen: handleOpenCredentialStoreForm,
    open: credentialStoreFormOpenState,
  } = useToggleState();

  return (
    <>
      {!credentialStoreFormOpenState && (
        <CredentialStoreCard
          storeName={paymentCredentials.credential_store_name}
          actions={
            <>
              <OSActionButton
                variant="outlined"
                size="large"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenCredentialStoreForm();
                }}
                actionStyle="edit"
              >
                Edit Credential
              </OSActionButton>
              <OSActionButton
                variant="outlined"
                size="large"
                color="error"
                actionStyle="custom"
                customIcon={<RemoveCircle />}
                onClick={onUnassignCredential}
              >
                Unassign Credential
              </OSActionButton>
            </>
          }
        />
      )}

      {credentialStoreFormOpenState && (
        <Stack spacing={2}>
          <CredentialStoreForm
            credentialStoreId={paymentCredentials.credentials_store}
            onFormCancel={handleCloseCredentialStoreForm}
          />
        </Stack>
      )}
    </>
  );
};
